import { render, staticRenderFns } from "./GIcon.vue?vue&type=template&id=04ef1d82&scoped=true&"
import script from "./GIcon.vue?vue&type=script&lang=js&"
export * from "./GIcon.vue?vue&type=script&lang=js&"
import style0 from "./GIcon.vue?vue&type=style&index=0&id=04ef1d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef1d82",
  null
  
)

export default component.exports